import styled from '@emotion/styled';

export const TitleContainer = styled.div`
    margin: ${({ theme }) => theme.spacing[4]} 0px 0px ${({ theme }) => theme.spacing[4]};
`;

export const Container = styled.div`
    heigth: 100%;
    flex-wrap: wrap;
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
    margin: ${({ theme }) => theme.spacing[4]};
    display: grid;
    grid-template-columns: 33% 33% 33%;
`;

export const Item = styled.div`
    margin: ${({ theme }) => theme.spacing[4]} ${({ theme }) => theme.spacing[4]};
`;

export const MultiRestaurantsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
`;

export const MultiRestaurantsDropdownContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing[10]};
`;

export const SelectContainer = styled.div`
    min-width: fit-content;
    width: 100%;
`;

export const FamiliesContainer = styled.div`
    font-family: ${({ theme }) => theme.font.family};
    background-color: ${({ theme }) => theme.color.white200};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[3]};
    margin: ${({ theme }) => theme.spacing[4]};
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: ${({ theme }) => theme.spacing[3]};
`;

export const FamilyCard = styled.div<{ isDragging?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[2]};
    border: 1px solid ${({ theme, isDragging }) => (isDragging ? theme.color.emerald : theme.color.grey200)};
    border-radius: ${({ theme }) => theme.radius.main};
    background-color: ${({ theme }) => theme.color.white100};
    box-shadow: ${({ isDragging }) => (isDragging ? '0 4px 8px rgba(0, 0, 0, 0.15)' : 'none')};
`;

export const DragHandle = styled.div`
    cursor: grab;
    color: ${({ theme }) => theme.color.grey500};
    background-color: ${({ theme }) => theme.color.grey100};
    border-radius: 4px;
    padding: 2px 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${({ theme }) => theme.color.grey200};
    }

    &:active {
        cursor: grabbing;
        background-color: ${({ theme }) => theme.color.grey300};
    }
`;

export const FamilyImage = styled.img`
    width: 70px;
    height: 70px;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.radius.main};
    margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const FamilyNameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[1]};
    margin-top: ${({ theme }) => theme.spacing[1]};
`;

export const FamilyName = styled.span`
    font-weight: ${({ theme }) => theme.font.weight.medium};
    font-size: 13px;
    text-align: center;
`;

export const DeleteButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.color.bloodyMary};
    color: white;
    cursor: pointer;
    padding: 0;
    font-size: 12px;

    &:hover {
        opacity: 0.8;
    }
`;

export const EmptyMessage = styled.span`
    color: ${({ theme }) => theme.color.grey500};
    font-style: italic;
`;

export const NewFamilyForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${({ theme }) => theme.spacing[2]};
    border: 2px dashed ${({ theme }) => theme.color.grey300};
    border-radius: ${({ theme }) => theme.radius.main};
    background-color: ${({ theme }) => theme.color.white100};
    gap: ${({ theme }) => theme.spacing[1]};
    justify-content: center;
`;

export const NewFamilyTitle = styled.span`
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.color.grey500};
`;

export const NewFamilyInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const SmallImageInput = styled.div`
    transform: scale(0.5);
    transform-origin: center;
    margin: -45px 0 -40px 0;
`;
